// @flow

import './index.scss';
import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import parseHTMLEntities from 'utils/parseHTMLEntities';
import dayjs from 'dayjs';

import type { Article } from 'stores/api/articles';

type Props = {|
    data: Article
|};

const ArticleCard = ({ data }: Props): React.Node => {
    const { __ } = useTranslate();
    const { title, _embedded, date, content } = data;
    const stripHTMLTags = React.useCallback((value: string) => value.replace(/<\/?[^>]+(>|$)/g, ''), []);

    return (
        <a
            className="ArticleCard"
            href={data.link}
            rel="noopener noreferrer"
            target="_blank"
            title={parseHTMLEntities(title.rendered)}
        >
            <div className="ArticleCard__picture-container">
                <img
                    className="ArticleCard__picture"
                    alt={parseHTMLEntities(title.rendered)}
                    src={_embedded['wp:featuredmedia'][0].source_url}
                />
            </div>
            <section className="ArticleCard__details">
                <div className="ArticleCard__title">
                    {parseHTMLEntities(title.rendered)}
                </div>
                <time className="ArticleCard__date">
                    {dayjs(date).format('DD MMMM YYYY')}
                </time>
                <p className="ArticleCard__description">
                    {stripHTMLTags(parseHTMLEntities(content.rendered))}
                </p>
                <div className="ArticleCard__footer">
                    <hr className="ArticleCard__separator" />
                    <span
                        className="ArticleCard__link"
                    >
                        {__('read-more')}
                    </span>
                </div>
            </section>
        </a>
    );
};

export default ArticleCard;
